<template>
  <div class="container gpx-tutorial">
    <h1>Como exportar seu GPX</h1>
    <p class="lede">
      Aqui na Largada Esportiva aceitamos arquivos no formato <strong>.gpx</strong>.
      A maioria dos relógios e apps exporta nesse formato — alguns por padrão,
      outros precisam de um clique extra. Veja como gerar o seu:
    </p>

    <section>
      <h2>Strava</h2>
      <ol>
        <li>Entre no Strava pelo navegador (não funciona pelo app).</li>
        <li>Abra a atividade da corrida que você quer enviar.</li>
        <li>Clique no menu <strong>...</strong> (três pontinhos) no canto superior direito.</li>
        <li>Selecione <strong>Exportar GPX</strong>.</li>
        <li>O arquivo cai na pasta de Downloads do seu computador.</li>
      </ol>
    </section>

    <section>
      <h2>Garmin Connect</h2>
      <ol>
        <li>Entre no <a href="https://connect.garmin.com" target="_blank" rel="noopener">connect.garmin.com</a>.</li>
        <li>Abra a atividade.</li>
        <li>No menu de engrenagem <strong>⚙</strong>, escolha <strong>Exportar para GPX</strong>.</li>
        <li>Salve o arquivo no computador.</li>
      </ol>
    </section>

    <section>
      <h2>Polar Flow</h2>
      <ol>
        <li>Acesse <a href="https://flow.polar.com" target="_blank" rel="noopener">flow.polar.com</a>.</li>
        <li>Abra a atividade no calendário.</li>
        <li>Clique nos três pontinhos, depois em <strong>Exportar sessão</strong> → <strong>Exportar GPX</strong>.</li>
      </ol>
    </section>

    <section>
      <h2>Coros / Suunto / Outros</h2>
      <p>
        A forma mais segura é conectar a conta ao Strava e exportar o GPX por lá.
        Quase todos os relógios sincronizam automaticamente.
      </p>
    </section>

    <section class="tips">
      <h2>Dicas</h2>
      <ul>
        <li>Verifique se o GPS estava ativado durante a corrida (sem trace = sem comprovação).</li>
        <li>Não edite manualmente o arquivo — qualquer recorte/colagem invalida a análise.</li>
        <li>Tamanho máximo: 100 MB (o suficiente até para ultras de mais de 20 horas).</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'gpx-tutorial',
};
</script>

<style scoped>
.gpx-tutorial {
  padding: 2em 0;
  max-width: 760px;
}
.lede {
  font-size: 1.05em;
  color: #555;
}
section {
  margin: 1.6em 0;
}
section h2 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 0.3em;
}
section ol,
section ul {
  padding-left: 1.4em;
}
section li {
  margin: 0.4em 0;
}
.tips {
  background: rgba(23, 162, 184, 0.07);
  border-radius: 8px;
  padding: 1em 1.4em;
}
</style>
